import React, { Component } from 'react';
import { Trans, translate } from 'react-i18next';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';

class SuccessDialog extends Component {
  /*
  componentDidMount() {
    window.fbq('track', 'Purchase'); 
  }
  */
  render() {
    const name = this.props.room.name;
    const { t } = this.props;
    
    return(
      <div>
        <button
          className="hidden"
          data-target="#modalSuccess"
          data-toggle="modal"
          id="btnSuccess"
          type="button">
        </button>
        <div className="modal fade" id="modalSuccess" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <h4>{t('dashboard.room_payment.heading_success')}</h4>
                <p>
                  <Trans i18nKey="dashboard.room_payment.success">
                    Has hecho una reservación exitosa en {{name}}.
                  </Trans>
                </p>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-default"
                  data-dismiss="modal"
                  type="button">
                  {t('dashboard.room_payment.btn_success')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  translate('common'),
  withRouter
)(SuccessDialog);



// WEBPACK FOOTER //
// ./src/dashboard/reservations/payment/SuccessDialog.js